import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLFormElement> {
  private _roleSelect: HTMLSelectElement | null = null;
  private _engineerLicenseNoInput: HTMLInputElement | null = null;

  private _onRoleChange: (event: Event) => void;

  connect(): void {
    this._roleSelect = this._findRoleSelect();
    this._engineerLicenseNoInput = this._findEngineerLicenseNoInput();

    this._onRoleChange = this._roleChange.bind(this);

    this._startRoleChange();

    if (this._roleSelect) {
      this._setDisableToEngineerLicenseNo(this._roleSelect.value);
    }
  }

  disconnect(): void {
    this._stopRoleChange();
  }

  private _findRoleSelect() {
    return document.querySelector<HTMLSelectElement>("[name='user[role]']");
  }

  private _findEngineerLicenseNoInput() {
    return document.querySelector<HTMLInputElement>(
      "[name='user[engineer_license_no]']"
    );
  }

  private _startRoleChange() {
    this._roleSelect?.addEventListener("change", this._onRoleChange);
  }

  private _stopRoleChange() {
    this._roleSelect?.removeEventListener("change", this._onRoleChange);
  }

  private _roleChange(event: Event) {
    event.preventDefault();

    const target = event.target;

    if (target instanceof HTMLSelectElement) {
      this._setDisableToEngineerLicenseNo(target.value);
    }
  }

  private _setDisableToEngineerLicenseNo(value: string) {
    if (this._engineerLicenseNoInput) {
      this._engineerLicenseNoInput.disabled = value !== "engineer";

      if (value !== "engineer") {
        this._engineerLicenseNoInput.value = "";
      }
    }
  }
}
